/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Cache from 'fierry/flux/cache';

import Zoom from 'astro/client/zoom';

import HexGeneral from 'astro/client/map/hex.general';
import HexLocal from 'astro/client/map/hex.local';


export default class
{
  constructor (zoom)
  {
    this.zoom = zoom;
    this.hexGeneral = new HexGeneral(this.zoom);

    this.hexLocalCache = new Cache( (location) =>
    {
      return new HexLocal(location, this);
    });
  }


  getZoom ()
  {
    return this.zoom;
  }


  getGeneralHex ()
  {
    return this.hexGeneral;
  }


  getLocalHex (location)
  {
    return this.hexLocalCache.get(location);
  }


};
